import Tr from "translations/Translations";
import Dialog from "components/Dialog";
import React from "react";
import useId from "hooks/useId";
import Form from "components/Form";
import TextInput from "components/TextInput";
import Units from "./Units";
import INPUT_TYPE from "constants/INPUT_TYPE";
import VS from "constants/ValidationShema";
import InputLimits from "constants/InputLimits";
import DoubleButton from "components/popup/components/DoubleButton";
import {withStyles} from '@material-ui/core';
import {connect} from "react-redux";
import BooleanItems from "constants/BooleanItems";
import {SOURCE_TYPES} from "constants/OfferSourceTypes";
import OfferSourceTypes from "constants/OfferSourceTypes";
import Select from "components/Select";
import getObjectValue from "libs/getObjectValue";
import VatField from "components/VatField";
import {SELECT_VALUE} from "constants/VATItems";
import {PriceTypeVatFieldVisible, PriceTypeNetFieldVisible, PriceTypeGrossFieldVisible} from "constants/PriceTypes";
import NetGrossField from "components/NetGrossField";
import {ItemTypes} from "../../constants/itemTypes";

const style = theme => ({
    actions: {
        marginTop: theme.spacing(2)
    }
})

function ItemPopup(
    {
        editable,
        onClose,
        onSubmit,
        itemElement,
        weightVisible,
        classes,
        formSubmit,
        priceType
    }) {
    const formId = useId();
    const inputLimits = InputLimits.procedure.dealings;
    const option = !!itemElement.baseItemId;

    const handleClose = () => {
        onClose();
    }

    const handleSave = () => {
        formSubmit[formId]();
    }

    const handleSubmit = (values) => {
        onSubmit(values);
    }

    const validationSchema = (priceType) => {
        return VS.object({
            name: VS.stringMax(inputLimits.NAME).nullable(),
            description: VS.stringMaxNoRq(100000).nullable(),
            quantity: VS.object({
                value: VS.numberMax(1000000000000000),
                uom: VS.string().nullable()
            }),
            type: VS.string(),
            offerVatPredefined: VS.string(),
            offerSourceType: VS.string(),
            offerValue: VS.any().when("offerSourceType", {
                is: offerSourceType => SOURCE_TYPES.INITIATOR === offerSourceType && PriceTypeNetFieldVisible(priceType),
                then: VS.amount(0, false),
                otherwise: VS.any()
            }),
            offerVatRate: VS.any().when(["offerVatPredefined", "offerSourceType"], {
                is: (offerVatPredefined, offerSourceType) =>  {
                    return offerVatPredefined === true || offerVatPredefined === 'true' || (SOURCE_TYPES.INITIATOR === offerSourceType && PriceTypeVatFieldVisible(priceType))
                },
                then: VS.string(),
                otherwise: VS.any()
            }),
            offerVatRateOther: VS.any().when(["offerVatPredefined", "offerSourceType", "offerVatRate"], {
                is: (offerVatPredefined, offerSourceType, offerVatRate) =>  {
                    return (offerVatPredefined === true || offerVatPredefined === 'true' || SOURCE_TYPES.INITIATOR === offerSourceType) && offerVatRate === SELECT_VALUE.OTHER
                },
                then: VS.amountMax100(),
                otherwise: VS.any()
            }),
            offerGrossValue: VS.any().when("offerSourceType", {
                is: offerSourceType => SOURCE_TYPES.INITIATOR === offerSourceType && PriceTypeGrossFieldVisible(priceType),
                then: VS.amount(0, false),
                otherwise: VS.any()
            }),
            weight: weightVisible ? VS.amountMax100NoZero() : VS.amountMax100Optional()
        });
    }

    return (
        <Dialog
            title={!!itemElement.identity ? Tr('edit_item') : Tr('new_item')}
            open={true}
            maxWidth={'md'}
            onClose={handleClose}
            transitionDuration={0}
        >
            <Form
                id={formId}
                onSubmit={handleSubmit}
                initialValues={{
                    name: itemElement.name,
                    description: itemElement.description,
                    quantity: {
                        value: itemElement.quantity.value,
                        uom: itemElement.quantity.uom,
                    },
                    type: itemElement.type,
                    baseItemId: itemElement.baseItemId,
                    baseItemName: itemElement.baseItemName,
                    weight: itemElement.weight,
                    offerVatPredefined: itemElement.offerVatPredefined,
                    offerVatRate: itemElement.offerVatRate,
                    offerVatRateOther: itemElement.offerVatRateOther,
                    offerSourceType: itemElement.offerSourceType,
                    offerValue: itemElement.offerValue,
                    offerGrossValue: itemElement.offerGrossValue,
                    allowQuantityEditInOffer: itemElement.allowQuantityEditInOffer,
                    _editable: editable,
                }}
                validationSchema={validationSchema(priceType)}
            >
                {(formikProps) => (
                    <>
                        <TextInput
                            id={'name'}
                            label={Tr('name')}
                            formikProps={formikProps}
                            limit={inputLimits.NAME}
                            required
                            multiline
                        />
                        <TextInput
                            id={'description'}
                            label={Tr('description')}
                            formikProps={formikProps}
                            multiline
                        />
                        <Units
                            formikProps={formikProps}
                            unitDisabled={!!itemElement.baseItemId}
                        />
                        <Select
                            label={Tr('position_type')}
                            formikProps={formikProps}
                            id={'type'}
                            required
                            disabled
                            items={ItemTypes}
                        />
                        {option && <TextInput
                            id={'baseItemName'}
                            label={Tr('position_type_basic')}
                            formikProps={formikProps}
                            multiline
                            disabled
                        />}
                        {!option && <Select
                            label={Tr('offerVatPredefined')}
                            formikProps={formikProps}
                            id={'offerVatPredefined'}
                            required
                            disabled={!PriceTypeVatFieldVisible(priceType)}
                            items={BooleanItems}
                        />}
                        {!option && getObjectValue('offerVatPredefined', formikProps.values, false) &&
                            <VatField
                                formikProps={formikProps}
                                required
                                editable={editable}
                                title={'offerVatPredefinedValue'}
                            />
                        }
                        {!option && <Select
                            label={Tr('offerSourceType_long')}
                            formikProps={formikProps}
                            id={'offerSourceType'}
                            required
                            items={OfferSourceTypes}
                        />}
                        {!option && getObjectValue('offerSourceType', formikProps.values, SOURCE_TYPES.SUPPLIER) === SOURCE_TYPES.INITIATOR &&
                        <NetGrossField
                            pathPrefix={'offer'}
                            formikProps={formikProps}
                            required
                            editable={editable}
                            title={Tr('offerSourceType_value')}
                            priceType={priceType}
                        />
                        }
                        {!option && <Select
                            label={Tr('allowQuantityEditInOffer_long')}
                            formikProps={formikProps}
                            id={'allowQuantityEditInOffer'}
                            required
                            items={BooleanItems}
                        />}
                        {weightVisible && <TextInput
                            id={'weight'}
                            type={INPUT_TYPE.NUMBER_19}
                            step="0.01"
                            label={Tr('weight')}
                            endAdornment={'%'}
                            formikProps={formikProps}
                            required
                        />}
                    </>
                )}
            </Form>
            <div className={classes.actions}>
                {editable && <DoubleButton
                    justify='flex-end'
                    labelFirst={Tr('cancel')}
                    labelSecond={!!itemElement ? Tr('save') : Tr('add')}
                    onClickFirst={handleClose}
                    onClickSecond={handleSave}
                />}
            </div>
        </Dialog>
    )
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(withStyles(style)(ItemPopup));